export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string; adminOnly?: boolean }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'projects',
      displayName: 'menu.projects',
      meta: {
        icon: 'folder_shared',
      },
    },
    {
      name: 'channels',
      displayName: 'menu.channels',
      meta: {
        icon: 'mso-link',
      },
    },
    {
      name: 'emails',
      displayName: 'menu.emails',
      meta: {
        icon: 'email',
      },
    },
    {
      name: 'logs',
      displayName: 'menu.logs',
      meta: {
        icon: 'history',
      },
    },
    {
      name: 'push-template-errors',
      displayName: 'menu.pushTemplateErrors',
      meta: {
        icon: 'error',
      },
    },
    {
      name: 'admin-users',
      displayName: 'menu.users',
      meta: {
        icon: 'people',
        adminOnly: true,
      },
    },
  ] as INavigationRoute[],
}
